<div class="initial-stock-rvo-check flex__child--none">
  <mat-checkbox [checked]="checked" [disabled]="disabled" (change)="onChange($event.checked)">
    <span class="initial-stock-rvo-check__label">{{ 'initialStockMatchesRvo' | translate }}</span>
    <span class="initial-stock-rvo-check__hint">{{
      'initialStockMatchesRvoReminder' | translate
    }}</span>
  </mat-checkbox>
</div>
